import { Component, OnInit, Input } from '@angular/core'
import { CustomerPaymentsOutput } from '../../../models/account-ledger.model';
import { Router, ActivatedRoute } from '@angular/router'
import { GetCSPTenant } from '../../../models/csp.model';
import { ManageService } from '../../../services/manage.service';


@Component({
  selector: 'app-subscription-payment-detail',
  templateUrl: './subscription-payment-detail.component.html',
  styleUrls: ['./subscription-payment-detail.component.css']
})
export class SubscriptionPaymentDetail implements OnInit {

  @Input() paymentMethod: CustomerPaymentsOutput = null;
  @Input() UsageAlert: boolean = false;
  @Input() digitalWalletId: string = '';
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService) {
  }

  ngOnInit() {

  }


  editPaymentDetails(event: any): void {
    this.manageService.monitorCurrentPaymentDetails({
      purchaseAccess: '',
      digitalWalletId: this.digitalWalletId
    });
    this.router.navigate(['EditPaymentDetails'], { relativeTo: this.activatedRoute });
  }
}
